import type * as React from 'react';
const SvgIcoNewVariables = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.8 19.17c1.21 0 2.192-.98 2.192-2.192v-4.382l1.095-1.096-1.095-1.096V6.022c0-1.21-.981-2.192-2.192-2.192M5.2 3.83c-1.21 0-2.191.981-2.191 2.192v4.382L1.913 11.5l1.096 1.096v4.382c0 1.211.98 2.192 2.191 2.192M8.898 12.011l1.757 1.757 3.834-3.835"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgIcoNewVariables;
